import moment from 'moment';

export const calculateAge = (date: string): number => {
    return moment(moment()).diff(moment(date), 'years');
};
